import React from "react";
import { ChromePicker } from "react-color";
import rgbHex from "rgb-hex";
import styles from "./ColorPicker.module.css";

// `optional`: the colour may be left empty, and the store then works it out
// from its other colours ("Automatic"). `startColor` is where the picker
// starts when the seller chooses one. `defaultColor`: the colour's default,
// offered back ("Use default") once it is changed.
const ColorPickerComponent = ({ name, SetColor, C_Color, optional = false, startColor = "#ffffff", defaultColor = null }) => {
  const auto = optional && !C_Color;
  const changed = defaultColor && String(C_Color).toLowerCase() !== defaultColor.toLowerCase();
  return (
    <div className={styles["color-picker-container"]}>
      <div className={styles["color-header"]}>
        <p className={styles["color-label"]}>{name}</p>
        {auto ? (
          <div className={`${styles["color-preview"]} ${styles["color-preview-auto"]}`}>
            <span className={styles["color-auto"]}>Automatic</span>
          </div>
        ) : (
          <div
            className={styles["color-preview"]}
            style={{ backgroundColor: C_Color }}
          >
            <span className={styles["color-code"]}>{C_Color}</span>
          </div>
        )}
      </div>
      {auto ? (
        <button type="button" className={styles["color-choose"]} onClick={() => SetColor(startColor)}>
          Choose colour
        </button>
      ) : (
        <>
          <div className={styles["picker-wrapper"]}>
            <ChromePicker
              color={C_Color}
              onChange={(c) =>
                SetColor("#" + rgbHex(c.rgb.r, c.rgb.g, c.rgb.b, c.rgb.a))
              }
              width="100%"
            />
          </div>
          {optional && (
            <button type="button" className={styles["color-reset"]} onClick={() => SetColor("")}>
              Use automatic
            </button>
          )}
          {changed && (
            <button type="button" className={styles["color-reset"]} onClick={() => SetColor(defaultColor)}>
              Use default
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default ColorPickerComponent;
